import 'debug';
import { d as pageMixin, t as throttle } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import { _ as __vue_normalize__ } from './normalize-component.js';

//
var script = {
  mixins: [pageMixin],
  created: function created() {
    this.goToNextPage = throttle(this.goToNextPage);
  },
  mounted: function mounted() {
    this.$xp.history.addHomePage(this.$route.params.id, this.$route.path, this.pageData.Title);
    this.$el.focus();
  },
  methods: {
    goToNextPage: function goToNextPage(e) {
      // console.log('goToNextPage()', e)
      if (this.pageData.NextPageID) {
        this.$router.push('/page/' + this.pageData.NextPageID);
      } else {
        console.warn("Splash screen has no next page");
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "a",
    {
      staticClass: "c-splash-page link",
      attrs: { role: "link", "aria-label": "Weiter", href: "#" },
      on: {
        click: function($event) {
          $event.preventDefault();
          return _vm.goToNextPage($event)
        },
        touchend: function($event) {
          $event.preventDefault();
          return _vm.goToNextPage($event)
        }
      }
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
